<div class="row">
  <div id="list">
    <h6>Lista de Errores y Alertas</h6>
    <div id="container-alerts" *ngFor="let invoiceAlert of invoiceAlerts">
      <p [ngClass]="invoiceAlert.alertType == 1 ? 'message-error' : 'message-alert'">
        {{invoiceAlert.message}}
      </p>
    </div>
  </div>
  <div class="row pt-3">
    <div class="d-flex justify-content-end">
      <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
        (onClick)="downloadErrorsTxt()"></app-custom-button>
    </div>
  </div>
</div>